'use strict';

const Mn = require('backbone.marionette');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const CoverView = require('feedback/ui/view/cover');
const CommentView = require('feedback/ui/view/idea/comment');
const Template = require('feedback/ui/template/idea/detail.hbs');
const Marked = require('balus/util/marked');
const IdeaRepository = require('feedback/domain/repository/idea');

/**
 * ユーザからの要望を詳しく表示する View
 * (要望詳細、コメント一覧、コメント投稿フォームを内包する)
 */
module.exports = Mn.View.extend({
    tagName: 'div',
    className: 'feedback-detail',
    template: Template,
    regions: {
        sidebar: '#sidebar',
        cover: '#cover',
    },
    modelEvents: {
        'change': 'render'
    },

    initialize: function() {
        IdeaRepository.fetchCommentsByIdea(this.model);
        this.listenTo(this.model.comments, 'add reset', this.render);
    },

    templateContext: function() {
        return {
            isPrivate: this.model.isPrivate(),
            body: Marked()(this.model.getBody()),
            stateColor: this.model.getState().color,
            commentNum: this.model.getCommentCount()
        };
    },

    onDomRefresh: function() {
        this.showChildView('cover', new CoverView({isIdea: true}));

        const navs = new SidebarCollection(
            [
                {
                    name: 'comment',
                    icon: 'fa fa-comments-o',
                    label: 'module/word:comment',
                    view: new CommentView({
                        model: this.model,
                        collection: this.model.comments
                    }),
                    open: true
                },
            ]
        );

        this.showChildView('sidebar', new SidebarView({
            navs: navs,
            horizontalNav: true
        }));


        $.material.init();
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/view/idea/detail.js